module.exports = __webpack_public_path__ + "img/1499696459.8401cf4a.jpg";